import { useState } from 'react'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'

export default function PopupConfirm({
  trigger = <Button>Open Confirm Dialog</Button>,
  title = 'Are you sure?',
  description = 'This action cannot be undone.',
  onConfirm,
  confirmText = 'Xác nhận',
  cancelText = 'Hủy',
  confirmButtonVariant = 'default',
  isOpen = false,
  showTooltip = false,
}) {
  const [open, setOpen] = useState(isOpen)

  const handleConfirm = () => {
    onConfirm()
    setOpen(false)
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      {showTooltip ? (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <DialogTrigger
                asChild
                onClick={(e) => {
                  e.stopPropagation()
                  setOpen(true)
                }}
              >
                {trigger}
              </DialogTrigger>
            </TooltipTrigger>
            <TooltipContent>Xóa</TooltipContent>
          </Tooltip>
        </TooltipProvider>
      ) : (
        <DialogTrigger
          asChild
          onClick={(e) => {
            e.stopPropagation()
            setOpen(true)
          }}
        >
          {trigger}
        </DialogTrigger>
      )}
      <DialogContent
        className="sm:max-w-[425px]"
        onClick={(e) => {
          e.stopPropagation()
        }}
      >
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => setOpen(false)}>
            {cancelText}
          </Button>
          <Button variant={confirmButtonVariant} onClick={handleConfirm}>
            {confirmText}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
